import { stopVendorTracking } from "@/lib/vendor-tracking-stop";

/**
 * React to analytics allowance transitions from loaders and SPA pageview hooks.
 * When denied, hard-stop vendors; when granted, loaders mount scripts themselves.
 */
export function onAnalyticsAllowanceChanged(allowed: boolean): void {
  if (!allowed) {
    stopVendorTracking();
  }
}

/** Marketing loaders use a separate consent category and never affect analytics. */
export function onMarketingAllowanceChanged(allowed: boolean): void {
  if (!allowed) {
    stopVendorTracking({ marketingOnly: true });
  }
}
